/** Maps full Rocket status label to single-letter API code. Returns null if unset or unknown. */
export function findUpdatedRocketStatusCharacter(
  rocketStatusFullString: null | string
): 'P' | 'C' | 'X' | null {
  if (rocketStatusFullString === 'Pending - called but task list not complete') return 'P';
  if (rocketStatusFullString === 'Complete - task list now filled in') return 'C';
  if (rocketStatusFullString === 'Needs a call - willing to help this time?') return 'X';
  return null;
}
